// Afroyla config for the BS26 "Build your sale list" quiz: questions, copy, style → design map, recipient defaults.
// Copy rule (anh 11-01): plain, clear words. No metaphors, no slogans — say what the product is.
// Store-specific values (brand, dates, SMS number/keyword, share text, calendar start) come from the section via window.SLQ_PAGE.
window.SLQ_CONFIG = Object.assign({
  tiers: [0, 0.65, 0.70, 0.75, 0.80],
  topPicks: false, // "Popular in the sale" row — OFF (anh 11-02: confusing above the quiz)
  // Photo strip order (11-01 HC Pixel: most opened/added designs first, both quiz pages).
  marqueeDesigns: ['Serwa Black', 'Eliora', 'Zuriya', 'Imani Blue Orchid', 'Dope Black Mom', 'Aina Coconut White', 'Serwa Brown', 'Locella', 'Njia', 'Sanaa Salt Pop'],
  // Browse-tab filter = the same style groups as the quiz (Afroyla has no store style collections).
  collections: [{ id: 'faith', label: 'Faith words' }, { id: 'mama', label: 'Made for moms' }, { id: 'rise', label: 'Portrait art' }, { id: 'locs', label: 'Locs portrait' },
    { id: 'bold', label: 'Positive words' }, { id: 'lowkey', label: 'Solid color, no print' }, { id: 'extras', label: 'Little extras' }], // index = item count (4+ uses 0.80)

  who: {
    q: 'Who are you shopping for?',
    options: [
      { id: 'both', label: 'Me + gifts' },
      { id: 'gifts', label: 'Gifts only' },
      { id: 'me', label: 'Just me' },
    ],
  },

  recipients: {
    q: 'Who’s on your list?',
    sub: 'Tap all that apply.',
    options: [
      { id: 'mama', for: 'Mom', label: 'Mom / Grandma', her: 'Mom', types: ['small handbag', 'handbag', 'crossbody'], looks: ['faith', 'mama'], extraLook: 'mama' },
      { id: 'sister', for: 'your sister', label: 'Sister', her: 'your sister', types: ['crossbody', 'small handbag', 'mini wallet'], looks: ['rise', 'bold'] },
      { id: 'daughter', for: 'your daughter', label: 'Daughter / granddaughter', her: 'her', types: ['crossbody', 'tote', 'backpack'], looks: ['rise', 'locs', 'bold'] },
      { id: 'church', for: 'a church friend', label: 'Church friend', her: 'her', types: ['wallet', 'mini wallet', 'makeup bag'], looks: ['faith'] },
      { id: 'coworker', for: 'a coworker', label: 'Coworker', her: 'her', types: ['mini wallet', 'wallet', 'makeup bag'], looks: ['lowkey', 'rise'] },
      { id: 'wife', for: 'your wife', label: 'Wife / partner', her: 'her', types: ['handbag', 'small handbag', 'tote'], looks: ['rise', 'lowkey'] },
      { id: 'hardest', for: 'someone hard to shop for', label: 'Someone hard to shop for', her: 'her', types: ['wallet', 'small handbag'], looks: ['top'] },
    ],
  },

  // Asked about the shopper's own bag (Me / Me and others). Each answer maps to bag types.
  // why = shown only for whyTypes (checked against the real product type); whyAlt otherwise.
  moment: {
    q: 'Where will you use your bag most?',
    options: [
      { id: 'sunday', label: 'Church', types: ['handbag', 'tote', 'small handbag'], why: 'Big enough for a Bible', whyTypes: ['handbag', 'tote'], whyAlt: 'Small and light for church' },
      { id: 'work', label: 'Work (fits a laptop)', types: ['tote', 'handbag'], why: 'Fits a 13″ laptop', whyTypes: ['tote', 'handbag'], whyAlt: 'Room for work things' },
      { id: 'everyday', label: 'Every day', types: ['small handbag', 'crossbody', 'handbag'], why: 'Good size for every day' },
      { id: 'light', label: 'Hands-free', types: ['crossbody', 'small handbag'], why: 'Light, worn across the body', whyTypes: ['crossbody'], whyAlt: 'Small and light' },
      { id: 'trip', label: 'Travel', types: ['backpack', 'tote'], why: 'Big enough for trips', whyTypes: ['backpack', 'tote'], whyAlt: 'Easy to travel with' },
    ],
  },

  // Gifts-only path: what kind of gifts (type + rough price in one tap).
  giftKind: {
    q: 'What kind of gifts?',
    options: [
      { id: 'bags', label: 'Bags', sub: 'from $17.99', types: ['small handbag', 'crossbody', 'handbag', 'tote'] },
      { id: 'little', label: 'Small gifts', sub: 'from $7.99', types: ['mini wallet', 'wallet', 'makeup bag', 'charm'] },
      { id: 'mix', label: 'A mix', types: null },
    ],
  },

  // Style = what is printed on the bag. Tiles show a real product photo of that style.
  // One plain line per design: what is actually on the bag (from the ops sheet artwork notes).
  designIntro: {
    'Aina Coconut White': 'Portrait of a woman in a crown, with graffiti words, on white.',
    'Aina Grape Soda': 'Portrait of a woman in a crown, in purple tones.',
    'Sanaa Salt Pop': 'Portrait of a woman in bold color blocks.',
    'Locella': 'A woman with long locs and the words “Let these locs do the talking.”',
    'Njia': 'Gold portrait with the words “She who walks with God always reaches her destination.”',
    'Imani Blue Orchid': 'A Bible verse with butterflies and flowers.',
    'Eliora': 'Quilted brown leather with “Live by Faith, Grow in Grace, Walk in Love.”',
    'Serwa Black': 'Solid black leather with gold hardware. No print.',
    'Safiya Brown Chain': 'Solid brown leather with a chain strap. No print.',
    'Zuriya': 'Sunflowers and the words “Be your own kind of beautiful.”',
    'Fahari Monochrome': 'Black and white, with the words Brave, Bold, Fearless, Worthy.',
    'AfroEssence': 'A woman meditating on a rainbow background.',
    'Dope Black Mom': 'Brown leather stamped “Dope Black Mom.”',
    'Tajimom': 'Red, with the words “Dopest Black Mom Periodt!”',
    'Chanua Bloom Charm': 'Layered leather charm: a woman in a head wrap with flowers and butterflies.',
    'Tunza Suede Earphones Case Charm': 'Lip-shaped suede case for AirPods.',
    'Macho Eyewear Case Charm': 'Eye-shaped case for glasses.',
  },

  look: {
    qMe: 'Which style do you like?',
    qHer: 'Which style fits your list?',
    options: [
      { id: 'faith', label: 'Faith words', designs: ['Njia', 'Imani Blue Orchid', 'Eliora'], why: 'Faith design' },
      { id: 'mama', label: 'Made for moms', designs: ['Dope Black Mom', 'Tajimom'], why: 'Mom design' },
      { id: 'rise', label: 'Portrait art', designs: ['Aina Coconut White', 'Sanaa Salt Pop', 'Aina Grape Soda'], why: 'Portrait art design' },
      { id: 'locs', label: 'Locs portrait', designs: ['Locella'], why: 'Locs portrait design' },
      { id: 'bold', label: 'Positive words', designs: ['Fahari Monochrome', 'AfroEssence', 'Zuriya'], why: 'Positive words design' },
      { id: 'lowkey', label: 'Solid color, no print', designs: ['Serwa Black', 'Safiya Brown Chain'], why: 'Solid color, no print' },
    ],
    giftOnlyExtra: { id: 'top', label: 'Not sure? Our #1 best seller', designs: ['Aina Coconut White'], why: 'Our #1 best seller' },
  },

}, window.SLQ_PAGE || {});
